import React from "react";

import {Route} from "react-router-dom";
import HomeScreenA8 from "./HomeScreen/index";
import ExploreScreen from "./ExploreScreen/ExploreScreen";
import who from "../reducers/who"
import {combineReducers, createStore} from "redux";
import {Provider} from "react-redux";
import tweets from "../reducers/tweets";
import profile from "../reducers/profile";
import EditProfileA8 from "../Challenge/EditProfile";
import ProfileScreenA8 from "../Challenge/ProfileScreen";

const store = createStore(combineReducers({tweets, who, profile}));

const BuildA8 = () => {
  return(
      <Provider store={store}>
        <div>
          <Route path={["/a8/twitter", "/a8/twitter/home"]}
               exact={true} component={HomeScreenA8}/>
          <Route path="/a8/twitter/explore"
               exact={true} component={ExploreScreen}/>
          <Route path="/a8/twitter/profile"
                 exact={true} component={ProfileScreenA8}/>
          <Route path="/a8/twitter/edit_profile"
                 exact={true} component={EditProfileA8}/>
        </div>
      </Provider>
  );
};
export default BuildA8;

